import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { IQuestion } from "@tsin-core/states/question/question.model";
import { environment } from "@tsin-env/environment";
import { Observable, catchError, throwError } from "rxjs";

const BASE_URL = `${environment.apiUrl}/interview/questions`;

@Injectable({
    providedIn: 'root'
})

export class QuestionService {

    http: HttpClient = inject(HttpClient);

    getQuestions(): Observable<IQuestion[]> {
        return this.http.get<IQuestion[]>(`${BASE_URL}`).pipe(
            catchError(error => {
                console.error('Error fetching questions:', error);
                return throwError(() => error);
            })
        );
    }
    getQuestion(id: string): Observable<IQuestion> {
        return this.http.get<IQuestion>(`${BASE_URL}/${id}`).pipe(
            catchError(error => {
                console.error('Error fetching questions:', error);
                return throwError(() => error);
            })
        );
    }
    
    createQuestion(formData: IQuestion): Observable<IQuestion> {
        return this.http.post<IQuestion>(`${BASE_URL}`, formData).pipe(
            catchError(error => {
                console.error('Error fetching questions:', error);
                return throwError(() => error);
            })
        );
    }
    
    updateQuestion(formData: IQuestion, id: string): Observable<IQuestion> {
        return this.http.put<IQuestion>(`${BASE_URL}/${id}`, formData).pipe(
            catchError(error => {
                console.error('Error fetching questions:', error);
                return throwError(() => error);
            })
        );
    }
   
   deleteQuestion(id: string): Observable<IQuestion> {
        return this.http.delete<IQuestion>(`${BASE_URL}/${id}`).pipe(
            catchError(error => {
                console.error('Error fetching questions:', error);
                return throwError(() => error);
            })
        );
    }
   
    assignRater(formData: IQuestion): Observable<IQuestion> {
        return this.http.put<IQuestion>(`${BASE_URL}/assign-rater`, formData).pipe(
            catchError(error => {
                console.error('Error fetching questions:', error);
                return throwError(() => error);
            })
        );
    }

}